import { render, staticRenderFns } from "./StringFormatter.Truncate.vue?vue&type=template&id=777c9700&scoped=true"
import script from "./StringFormatter.Truncate.vue?vue&type=script&lang=js"
export * from "./StringFormatter.Truncate.vue?vue&type=script&lang=js"
import style0 from "./StringFormatter.Truncate.vue?vue&type=style&index=0&id=777c9700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777c9700",
  null
  
)

export default component.exports